import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import qs from 'qs'

export default function ShopifyPostInstall() {
  const { search } = useLocation()

  useEffect(() => {
    // parse out whatever Shopify sent (you probably only need `shop`)
    const { shop } = qs.parse(search, { ignoreQueryPrefix: true })

    if (!shop) {
      // fallback if something’s missing
      window.location.href = '/'
      return
    }

    // Replace this with your real “app UI” URL:
    // e.g. `/dashboard`, `/`, or wherever your merchants start
    const appUiUrl = `/dashboard?shop=${encodeURIComponent(shop)}`

    // top-redirect (break out of any frame)
    window.top.location.href = appUiUrl
  }, [search])

  // Return a 200 HTML response with a script
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      🔄 Finalizing install… redirecting into your app.
    </div>
  )
}
